<template>
    <div
        class="f-formInput"
    >
        <input
            v-bind="$attrs"
            ref="formInput"
            class="k-c-input f-formInput__input"
            :class="{
                [`k-c-input--${status}`]: status,
                [`has-status-${status}`]: status,
            }"
            :value="modelValue"
            @input="onInput"
            @change="onChange"
        >
    </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue';

const props = withDefaults(defineProps<{
    modelValue: string | number | null;
    modelModifiers?: Record<string, boolean>;
    status?: string;
}>(), {
    modelModifiers: () => ({}),
});

const emit = defineEmits(['update:modelValue']);

const onChange = event => (props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);
const onInput = event => (!props.modelModifiers.lazy ? emit('update:modelValue', event.target.value) : null);

const input = useTemplateRef('formInput');

function focusInput() {
    input.value.focus();
}

defineExpose({ focusInput });
</script>

<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>

<style lang="scss">
@use '~@karriereat/global-styles/scss/settings/spacing';

.f-formInput {
    position: relative;
}
</style>
